import $ from "jquery";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AddressMap from "./components/AddressMap.vue";

const AccountMap = () => {
    Vue.use(VueGoogleMaps, {
        load: {
            key: "AIzaSyBtZ68jL6KzuY4WIzg2Bk2z9TzUb6qdZvs",
            libraries: "places"
        }
    });

    return new Vue({
        el: "#address-profile",
        data: {
            countries: window.PlUs.countries,
            strings: window.PlUs.strings,
            address: {
                name: "",
                surname: "",
                company_name: "",
                address: "",
                zip_code: "",
                district: "",
                city: "",
                country: "",
                telephone: "",
                primary: false,
                formatted_address: ""
            }
        },
        components: {
            "address-map": AddressMap
        },
        methods: {
            /**
             * Valuta se creare un nuovo indirizzo o modificarne uno esistente
             */
            checkAddress() {
                if (process.env.NODE_ENV === "development") {
                    console.log("@checkAddress");
                }
                // if(this.idAddressChange == null) {
                //     // creo un nuovo indirizzo
                //     this.createAddress(this.newAddress)
                // } else {
                //     // modifico un indirizzo
                //     this.changeAddress(this.idAddressChange, this.newAddress)
                // }
            }
        }
    });
};

export default AccountMap;
